export const styles = {
  control: (base) => ({
    ...base,
    minHeight: 8,
    height: 27,
    fontSize: 13,
    width: 173,
    alignContent: 'right',
    flexDirection: 'row',
    flex: 1,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
    fontSize: 13,
  }),
  clearIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 2,
    fontSize: 13,
  }),
  menu: (provided, state) => ({
    ...provided,
    fontSize: '14px', // set your desired font size here
  }),
};
export const styles3 = {
  control: (base) => ({
    ...base,
    minHeight: 8,
    height: 27,
    fontSize: 13,
    width: 80,
    backgroundColor: '#f5f0f0',
    alignContent: 'right',
    flexDirection: 'row',
    flex: 1,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
    fontSize: 13,
  }),
  clearIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 2,
    fontSize: 13,
  }),
  menu: (provided, state) => ({
    ...provided,
    fontSize: '14px', // set your desired font size here
  }),
};
export const styles4 = {
  control: (base) => ({
    ...base,
    minHeight: 8,
    height: 27,
    fontSize: 13,
    width: 80,
    backgroundColor: '#f5f0f0',
    alignContent: 'right',
    flexDirection: 'row',
    flex: 1,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
    fontSize: 13,
  }),
  clearIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 2,
    fontSize: 13,
  }),
  menu: (provided, state) => ({
    ...provided,
    fontSize: '14px', // set your desired font size here
  }),
};
export const selectTheme = (theme) => ({
  ...theme,
  borderRadius: 5,

  colors: {
    ...theme.colors,
    text: '#6b6868',
    primary25: '#f7e4da',
    primary: '#f5874f',
  },
});

export const styles2 = {
  control: (base) => ({
    ...base,
    minHeight: 8,
    height: 27,
    fontSize: 14,
    flexDirection: 'row',
    flex: 1,
    textOverflow: 'ellipsis',

    alignContent: 'center',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
    fontSize: 14,
  }),
  clearIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 2,

    fontSize: 14,
  }),
  menu: (provided, state) => ({
    ...provided,
    fontSize: '14px', // set your desired font size here
  }),
};

export const styles5 = {
  control: (base) => ({
    ...base,
    minHeight: 8,
    height: 27,
    fontSize: 14,
    zIndex: 9999,
    // backgroundColor: '#f5f0f0',
    flexDirection: 'row',
    width: '100px',
    display: 'flex',
    border: '0px solid',
    textOverflow: 'ellipsis',
    alignContent: 'center',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  clearIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 2,
  }),
  menu: (provided, state) => ({
    ...provided,
    fontSize: '12px', // set your desired font size here
    padding: 0,
    width: window.innerWidth <= 760 ? '80px' : '100%',
  }),
};
export const styles7 = {
  control: (base) => ({
    ...base,
    minHeight: 8,
    height: 32,
    fontSize: 14,
    zIndex: 9999,
    backgroundColor: '#f5f8fa',
    flexDirection: 'row',
    flex: 1,
    textOverflow: 'ellipsis',
    alignContent: 'center',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  clearIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 2,
  }),
  menu: (provided, state) => ({
    ...provided,
    fontSize: '12px', // set your desired font size here
    padding: 0,
    width: window.innerWidth <= 760 ? '80px' : '100%',
  }),
};

export const styles6 = {
  control: (base) => ({
    ...base,
    minHeight: 8,
    height: 35,
    fontSize: 14,
    zIndex: 9999,
    color: 'white',
    backgroundColor: '#c9c5c5',
    flexDirection: 'row',
    flex: 1,

    textOverflow: 'ellipsis',

    alignContent: 'center',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
    color: '#383535',
  }),
  clearIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 2,
  }),
  menu: (provided, state) => ({
    ...provided,
    fontSize: '13px', // set your desired font size here
    padding: 0,
    width: '100%',
  }),
};
